import React from 'react'
import ComingSoon from '../../pages/ComingSoon';

const ModuleReconciliation = () => {
  return (
    <div className=''>
        <ComingSoon />
    </div>
  )
}

export default ModuleReconciliation;